import ApisService from './index'
import {
  IPurchasesRequestAdd,
  IPurchasesRequestImport,
  IPurchasesRequestUpdate,
} from '../interfaces/purchasesRequestInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createPurchasesRequest(data: IPurchasesRequestAdd) {
  const bodyData = { ...data, ngayYeuCauNhanHangKhoVN: parseInt(data.ngayYeuCauNhanHangKhoVN), sanPhamId: Number(data.sanPhamId) }

  try {
    return ApisService.post('/yeucaumua/create-yeucaumua', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updatePurchasesRequest(data: IPurchasesRequestUpdate) {
  const bodyData = { ...data, ngayYeuCauNhanHangKhoVN: parseInt(data.ngayYeuCauNhanHangKhoVN), sanPhamId: Number(data.sanPhamId) }
  try {
    return ApisService.put('/yeucaumua/' + data.id + '/update-yeucaumua', bodyData)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailPurchasesRequest(id: string) {
  try {
    return ApisService.get('/yeucaumua/' + id + '/get-chitiet-yeucaumua')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListPurchasesRequest(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/yeucaumua/filter-yeucaumua', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deletePurchasesRequest(id: string) {
  try {
    return ApisService.delete('/yeucaumua/' + id + '/delete-yeucaumua')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultIPurchasesRequest(idArr: Array<string>) {
  try {
    return ApisService.delete('/yeucaumua/bulk-delete-yeucaumua', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function importPurchasesRequest(data: Array<IPurchasesRequestImport>) {
  try {
    return ApisService.post('/yeucaumua/import-yeucaumua', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function confirmPurchasesRequest(id: string) {
  try {
    return ApisService.put('/yeucaumua/' + id + '/dongy-baogia')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function rejectAllPurchasesRequest(id: any) {
  try {
    return ApisService.put('/yeucaumua/' + id + '/tuchoi-tatca-baogia')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function appendCmtMuaHang(id: string | number, noiDung: string) {
  try {
    return ApisService.post('/yeucaumua/' + id + '/cmt-muahang', { noiDung })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function appendCmtKinhDoanh(id: string | number, noiDung: string) {
  try {
    return ApisService.post('/yeucaumua/' + id + '/cmt-kinhdoanh', { noiDung })
  } catch (err) {
    handleError(err)
    throw err
  }
}
